module.exports = __webpack_public_path__ + "media/flags/008-saudi-arabia-09a6042f.svg";